import { EventEmitter } from 'events'

export const bus = new EventEmitter()

export const FILE_WATCHING_COMPLETE = 1
